import { render, staticRenderFns } from "./WidgetSlider.vue?vue&type=template&id=65bc0fa2&scoped=true"
import script from "./WidgetSlider.vue?vue&type=script&lang=js"
export * from "./WidgetSlider.vue?vue&type=script&lang=js"
import style0 from "./WidgetSlider.vue?vue&type=style&index=0&id=65bc0fa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bc0fa2",
  null
  
)

export default component.exports